import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import back from "../../images/widget-background.webp";
import RandomProducts from "./RandomProducts";
import { useCart } from "../../CartContext";

const categ = [
  {
    id: 1,
    cate: "All",
  },
  {
    id: 2,
    cate: "Phones",
  },
  {
    id: 3,
    cate: "Laptop",
  },
  {
    id: 4,
    cate: "Appliances",
  },
  {
    id: 5,
    cate: "Games",
  },
  {
    id: 6,
    cate: "Accessories",
  },
];

const ShopProducts = () => {
  const { addToCart, cart, decreaseQuantity } = useCart();
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(1000);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [showFilter, setShowFilter] = useState(false);
  const perPage = 12;

  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch("products.json")
      .then((res) => res.json())
      .then((data) => setProducts(data));
  }, []);

  const filtered = products
    .filter((prod) => prod.price >= minPrice && prod.price <= maxPrice)
    .filter(
      (prod) => selectedCategory === "All" || prod.category === selectedCategory
    );
  const startIndex = (currentPage - 1) * perPage;
  const paginated = filtered.slice(startIndex, startIndex + perPage);
  const totalPages = Math.ceil(filtered.length / perPage);
  return (
    <div className="flex items-start gap-3">
      <div className="w-[100%] lg:w-[80%] px-[10px]">
        <button
          className="bg-amber-500 py-[5px] px-[10px] rounded-[2px] text-[14px] flex items-center gap-2 mb-[20px] lg:hidden"
          onClick={() => setShowFilter(true)}
        >
          <i className="fa-solid fa-bars"></i>FILTERS
        </button>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-5">
          {paginated.map((p) => {
            const inCart = cart.find((item) => item.id === p.id);
            return (
              <div
                key={p.id}
                className="relative border-[1px] border-gray-300 rounded-[7px] flex flex-col items-center justify-center p-[15px]"
              >
                <NavLink
                  onClick={() => window.scrollTo({ top: 0 })}
                  className="text-center"
                  to={`/shop/${p.id}`}
                >
                  <img
                    src={p.image}
                    alt={p.name}
                    className="h-[200px] hover:scale-110 transition-all duration-500 ease-in-out"
                  />
                  <h2 className="font-[600] text-[18px]">{p.name}</h2>
                </NavLink>
                <i class="fa-regular fa-heart absolute top-[5%] left-[80%] bg-gray-200 p-[9px] rounded-full text-[13px] hover:bg-amber-500 hover:text-white cursor-pointer"></i>
                <span>
                  <NavLink
                    className="text-gray-400 text-[13px] py-[7px]"
                    to={`/${p.category}`}
                  >
                    {p.category}
                  </NavLink>
                </span>
                <div className="mt-[20px]">
                  {inCart && inCart.quantity > 0 ? (
                    <div className="flex items-center justify-between gap-11 px-[15px] font-[600]">
                      {inCart && inCart.quantity > 0 ? (
                        <NavLink
                          className={
                            "text-[12px] font-[600] text-gray-600 hover:text-amber-500 py-[5px] px-[10px] rounded-[5px]"
                          }
                          to={"/cart-page"}
                        >
                          VIEW IN CART
                        </NavLink>
                      ) : (
                        <div>
                          <span className="font-[600] text-[14px] text-gray-600">
                            ${p.price.toFixed(2)}
                          </span>
                        </div>
                      )}
                      <div className="">
                        <button
                          className={`${
                            inCart.quantity <= 1
                              ? "bg-gray-500"
                              : "bg-amber-500"
                          } text-white p-[5px] w-[40px]`}
                          onClick={() => decreaseQuantity(p.id)}
                        >
                          -
                        </button>
                        <span className="w-[40px] mx-[10px]">
                          {inCart.quantity}
                        </span>
                        <button
                          className="bg-amber-500 text-white p-[5px] w-[40px]"
                          onClick={() => addToCart(p)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-11 px-[15px] relative">
                      <p className="font-[600] text-[14px] text-gray-600">
                        ${p.price.toFixed(2)}
                      </p>
                      <span className="">|</span>
                      <button
                        onClick={() => addToCart(p)}
                        className="font-[600] text-[14px] text-gray-600 hover:text-amber-500"
                      >
                        ADD TO CART
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className="flex items-center justify-center gap-3 my-[40px]">
          {totalPages <= 1 ? (
            ""
          ) : (
            <i
              className="fa-solid fa-chevron-left"
              onClick={() =>
                currentPage <= 1 ? "" : setCurrentPage(currentPage - 1)
              }
            ></i>
          )}
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              className={`h-[30px] w-[30px] shadow-sm shadow-gray-400 rounded-full hover:bg-amber-500 ${
                currentPage === i + 1 ? "bg-amber-500 text-white" : ""
              }`}
              key={i}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          {totalPages > 1 ? (
            <i
              className="fa-solid fa-chevron-right"
              onClick={() =>
                currentPage < totalPages ? setCurrentPage(currentPage + 1) : ""
              }
            ></i>
          ) : (
            ""
          )}
        </div>
      </div>
      <div
        className={`w-[100%] lg:w-[20%] fixed lg:relative top-0 left-0 bg-white py-[40px] px-[20px] lg:px-[0px] max-h-[auto] z-30 transition-all ease-in-out duration-700 ${
          !showFilter
            ? "translate-x-[900px] opacity-0 lg:opacity-100 lg:translate-x-0"
            : "translate-x-0 opacity-100 lg:opacity-100 lg:translate-x-0"
        }`}
      >
        <button
          onClick={() => setShowFilter(false)}
          className="relative left-[90%] top-[-20px] block lg:hidden"
        >
          <i className="fa-solid fa-x"></i>
        </button>
        <div className="flex justify-between">
          <h3 className="font-[600]">Filter by Price Range</h3>
          <button
            className="bg-amber-500 py-[2px] px-[10px] rounded-[5px]"
            onClick={() => {
              setMinPrice(0);
              setMaxPrice(1000);
              setSelectedCategory("All");
            }}
          >
            Reset
          </button>
        </div>
        <div className="relative bg-gray-400 h-[5px] mt-[20px] rounded-full">
          <div
            className="absolute h-[100%] bg-amber-500"
            style={{
              left: `${(minPrice / 1000) * 100}%`,
              right: `${100 - (maxPrice / 1000) * 100}%`,
            }}
          ></div>
          <input
            type="range"
            name=""
            id="range"
            min={0}
            max={1000}
            value={minPrice}
            onInput={(e) => {
              const value = Math.min(Number(e.target.value), maxPrice); // prevent overlap
              setMinPrice(value);
            }}
          />
          <input
            type="range"
            name=""
            id="range"
            min={0}
            max={1000}
            value={maxPrice}
            onInput={(e) => {
              const value = Math.max(Number(e.target.value), minPrice); // prevent overlap
              setMaxPrice(value);
            }}
          />
        </div>
        <div className="flex gap-2 w-[100%] my-[15px]">
          <div className="flex flex-col">
            <label className="font-[600]">min</label>
            <input
              type="number"
              className="border-[1px] rounded-sm w-[100%]"
              value={minPrice}
              onInput={(e) => {
                e.target.value > maxPrice || e.target.value < 0
                  ? setMinPrice(minPrice)
                  : setMinPrice(e.target.value);
              }}
            />
          </div>
          <div className="flex flex-col">
            <label className="text-right font-[600]">max</label>
            <input
              type="number"
              className="border-[1px] rounded-sm w-[100%]"
              value={maxPrice}
              onInput={(e) => {
                e.target.value < minPrice || e.target.value > 1000
                  ? setMaxPrice(maxPrice)
                  : setMaxPrice(e.target.value);
              }}
            />
          </div>
        </div>
        {/* category */}
        <div>
          <h2 className="font-[600] mt-[30px]">Filter by Categories</h2>
          <div className="flex flex-wrap gap-2 justify-center my-[25px]">
            {categ.map((cat) => (
              <button
                className={`flex items-center justify-center py-[2px] rounded-sm px-[15px] ${
                  selectedCategory === cat.cate ? "bg-amber-500" : "bg-gray-200"
                }`}
                key={cat.id}
                onClick={() => setSelectedCategory(cat.cate)}
              >
                {cat.cate}
              </button>
            ))}
          </div>
        </div>

        {/* random */}
        <RandomProducts products={products} back={back} />
      </div>
    </div>
  );
};

export default ShopProducts;
